const soundmeters = {};
window.soundmeters = soundmeters;
// SOUNDMETER

// This number affects how often the soundmeter is updated
// Dont use a small number as this would cause an added impact on every soundmeter
// present in the screen, which could be a lot actually
// this value affects calibration as this is the way we detect if the user has spoken
// attempt to use a value less than a frame (41ms)
let soundmeterRefreshInterval = 15;

window.AudioContext = window.AudioContext || window.webkitAudioContext;
// this must be run after a user action

let audioCtx = null;
let loadedVueMeter = false;
window.startSoundMeterContext = function(){
  if (audioCtx == null){
    audioCtx = new AudioContext();
    // Adding an AudioWorkletProcessor
    // from another script with addModule method
    try{
      audioCtx.audioWorklet.addModule('/js/vumeter-processor.js').then(() => {
        // TODO: shouldnt this be behind an action tho
        loadedVueMeter = true;
      })
    } catch {
      console.error("Browser doesnt support Audio Worklets...")
    }
}
}

async function checkIfAudioWorkletIsLoaded(){
  return new Promise((resolve, reject) => {
    let counter = 0;
    const interval = setInterval(() => {
      if (loadedVueMeter){
        clearInterval(interval);
        resolve(true);
      }
      if (counter > 100){
        clearInterval(interval);
        reject(false);
      }
      counter++;
    }, 100);
  })
}


// args
// id of the stream
// audio stream to show audio levels
// type of display: 'bar' or 'avatar'
async function setupSoundMeter(id, stream, target = null, type = 'bar', activeCallback = null) {
  if (stream == null || stream.getAudioTracks === undefined) {
    if (soundmeters[id]) {
      // console.log("Clear soundmeter %s interval", id);
      await soundmeters[id].stop();
      clearInterval(soundmeters[id].interval);
      soundmeters[id] = null;
      delete soundmeters[id];
    }
    return;
  }

  if (soundmeters[id]) {
    // console.log("Clear soundmeter %s interval", id);
    await soundmeters[id].stop();
    clearInterval(soundmeters[id].interval);
    soundmeters[id] = null;
    delete soundmeters[id];
  }

  if (stream.getAudioTracks().length === 0) return;

  // important, check if the vumeter context is loaded before continuing
  await checkIfAudioWorkletIsLoaded()

  const soundMeter = new SoundMeter(id, audioCtx);
  soundmeters[id] = soundMeter;


  // const newStream = new MediaStream([stream.getAudioTracks()[0].clone()]);

  soundMeter.connectToSource(stream, (e) => {
    // console.log('setup soundmeter', id);
    if (e) { console.error(e); return; }
    soundMeter.interval = setInterval(() => {
      if (type === 'tower') colorTower(soundMeter, target, activeCallback);
      if (type === 'bar') colorMeter(soundMeter, soundMeter.id, soundMeter.instant.toFixed(2), target);
      if (type === 'avatar') {
        colorAvatar(soundMeter.id, soundMeter.instant.toFixed(2));
      }
    }, soundmeterRefreshInterval);
  });
}

async function colorTower(soundMeter, target, activeCallback) {
  // max value is 0.3 for 18
  // 0 ___ 0
  // 0.3 ___ 50
  const { id } = soundMeter;
  const value = soundMeter.instant.toFixed(2);

  const height = 32;
  let amount = value;
  amount = Math.log(amount) / Math.log(200) + 0.9;
  if (amount < 0) amount = 0;

  // -20dbs = 42 = 1.6 = 50% of vu meter
  // 0db = 428 = 2.6 =  100% of vu meter

  // 2.6 ____ 100%
  // 1.6 _____ 50%
  amount = height * (amount);
  if (amount > 1) $(id).removeClass('disabled');
  if (amount > height) amount = height;

  if (amount > height/3) {
    if (activeCallback) activeCallback(amount)
  }
  $(id).each(function () {
    $(this).find('.led').height(amount);
  });
}

async function colorMeter(soundMeter, id, value, target) {
  // max value is 0.3 for 18
  // 0 ___ 0
  // 0.3 ___ 50

  let maxWidth = 0;
  // get biggest width to avoid the issue when the first soundmeter in the DOM is display: none; and the width = 0, hence
  // it seems not to work, but is actually setting the max width to 0.
  $(id).each(function () {
    const width = $(this).width();
    if (width >= maxWidth) maxWidth = width;
  });
  const width = maxWidth;
  let amount = value;
  amount = Math.log(amount) / Math.log(200) + 0.9;
  if (amount < 0) amount = 0;

  // -20dbs = 42 = 1.6 = 50% of vu meter
  // 0db = 428 = 2.6 =  100% of vu meter

  // 2.6 ____ 100%
  // 1.6 _____ 50%
  amount = width * (amount);
  if (amount > 1) $(id).removeClass('disabled');
  if (amount > width) amount = width;

  $(id).each(function () {
    $(this).find('.led').width(amount);
  });
}

async function colorAvatar(id, value) {
  let amount = parseInt(value * 54);
  if (amount > 18) amount = 18;
  if (amount > 2) {
    $(id).addClass('bg-green-300');
  } else {
    $(id).removeClass('bg-green-300');
  }
}

// Meter class that generates a number correlated to audio volume.
// The meter class itself displays nothing, but it makes the
// instantaneous and time-decaying volumes available for inspection.
// It also reports on the fraction of samples that were at or near
// the top of the measurement range.
function SoundMeter(id, context) {
  this.id = id;
  this.context = context;
  this.instant = 0.0;
  this.dbs = 0.0;
  this.interval = null;
  // this.script = context.createScriptProcessor(0, 1, 1);

  // Creating AudioWorkletNode sending
  // context and name of processor registered
  // in vumeter-processor.js

  this.node = new AudioWorkletNode(this.context, 'vumeter');

  // Listing any message from AudioWorkletProcessor in its
  // process method here where you can know
  // the volume level
  this.node.port.onmessage = (event) => {
    // console.log("GOT MESSAGE", this.id, event.data.volume)
    let _volume = 0;
    const _sensibility = 60; // Just to add any sensibility to our ecuation
    if (event.data.volume) _volume = event.data.volume;
    const vol = (_volume * 100) / _sensibility;

    // DBs volume
    this.instant = vol;
    this.dbs = vol;
  };

  // old way

  // this.script.onaudioprocess = function (event) {
  //   const input = event.inputBuffer.getChannelData(0);
  //   let i;
  //   let sum = 0.0;
  //   for (i = 0; i < input.length; ++i) {
  //     sum += input[i] * input[i];
  //   }
  //   if (sum == 0) return;
  //   const gain = Math.sqrt(sum / input.length);
  //   that.instant = gain;
  //   that.dbs = 20 * Math.log10(gain);
  //   clearTimeout(this.meterTimeout);

  //   this.meterTimeout = window.setTimeout(() => {
  //     that.instant = 0.0001;
  //   }, 100);
  // };
  return this;
}

SoundMeter.prototype.connectToSource = function (stream, callback) {
  try {
    // this.mic = this.context.createMediaStreamSource(stream);
    // this.mic.connect(this.script);

    // // necessary to make sample run, but should not be.
    // this.script.connect(this.context.destination);

    // Creating a MediaStreamSource object
    // and sending a MediaStream object granted by
    // the user
    this.mic = this.context.createMediaStreamSource(stream);

    // Now this is the way to
    // connect our microphone to
    // the AudioWorkletNode and output from audioContext
    this.mic.connect(this.node).connect(this.context.destination);
    // this.node.connect(this.context.destination);
    if (typeof callback !== 'undefined') {
      callback(null);
    }
  } catch (e) {
    console.error(e);
    if (typeof callback !== 'undefined') {
      callback(e);
    }
  }
};

SoundMeter.prototype.stop = function () {
  this.node.port.onmessage = null;
  this.mic.disconnect();
  this.node.disconnect();
  this.node = null;
  this.mic = null;
};

window.setupSoundMeter = setupSoundMeter;

export { setupSoundMeter };
